import { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import ComponentCard from "../../../components/common/ComponentCard";
import Form from "../../../components/form/Form";
import Button from "../../../components/ui/button/Button";
import Label from "../../../components/form/Label";
import Input from "../../../components/form/input/InputField";
import Select from "../../../components/form/Select";

const apiUrl = process.env.REACT_APP_API_URL;

export default function UpdateRemedialActions() {
  const token = localStorage.getItem("token");
  const [formData, setFormData] = useState<any>()
  const navigate = useNavigate();
  const location = useLocation();
  const remedialActiondata = location.state?.remedialAction;

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    const payload = {
      // Construct payload based on formData
      inspectionaction_id: formData.inspectionaction_id,
      inspectionType: formData?.inspectionType,
      inspectionDate: formData?.inspectionDate,
      venue: formData?.venue,
      createdBy: formData?.createdBy,
      actionDate: formData?.actionDate,
      actionTitle: formData?.actionTitle,
      dateCompleted: formData?.dateCompleted,
      status: formData?.status,
      inspectionItem: formData?.inspectionItem,
      remarks: formData?.remarks,
    };

    //update remedial action
    const response = await fetch(`${apiUrl}/remedial_actions`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        token: token || "",
      },
      body: JSON.stringify(payload),
    });
    
    if(response.ok){
      navigate("/remedial-actions");
    }

  };

  //Handle text input changes
  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  useEffect(() => {
    if (remedialActiondata) {
      setFormData({
        inspectionaction_id: remedialActiondata.inspectionaction_id,
        inspectionType: remedialActiondata.insptype || "",
        inspectionDate: remedialActiondata.inspdate?.split("T")[0] || "",
        venue: remedialActiondata.venue || "",
        createdBy: remedialActiondata.createdby || "",
        actionDate: remedialActiondata.actiondate?.split("T")[0] || "",
        actionTitle: remedialActiondata.name || "",
        dateCompleted:
          remedialActiondata.datecompleted &&
          remedialActiondata.datecompleted !== "1900-01-01T00:00:00.000Z"
            ? remedialActiondata.datecompleted.split("T")[0]
            : "",
        status: remedialActiondata.status || "",
        inspectionItem: remedialActiondata.task || "",
        remarks: remedialActiondata.remarks || "",
      });
    }
  }, [remedialActiondata]);

  const getTodayDate = () => {
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, "0");
    const day = String(today.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

  return(
    <>
      <ComponentCard title="Update Remedial Actions">
        <Form onSubmit={handleSubmit}>
          <div className="grid grid-cols-1 gap-6 xl:grid-cols-2">
            <div className="space-y-6">
              <div className="rounded-2xl border border-gray-200 bg-white p-6 shadow-sm dark:border-gray-800 dark:bg-gray-900">
                <div className="grid gap-6 sm:grid-cols-2">
                  <div className="">
                    <Label htmlFor="firstName">Inspection Type</Label>
                    <Input type="text" id="inspectionType" value={formData?.inspectionType || ""} onChange={handleChange} 
                    />
                  </div>
                  <div className="">
                    <Label htmlFor="firstName">Inspection Date</Label>
                    <Input id="inspectionDate"  value={formData?.inspectionDate || ""} onChange={handleChange} />
                  </div>
                  <div className="">
                    <Label htmlFor="lastName">Venue</Label>
                    <Input id="SignOffDate"  value={formData?.venue || ""} onChange={handleChange}/>
                  </div>
                  <div className="">
                    <Label htmlFor="lastName">Created By</Label>
                    <Input id="inspectionToBeCompletedBy" value={formData?.createdBy || ""} onChange={handleChange} />
                  </div>
                  <div className="">
                    <Label htmlFor="firstName">Action Date</Label>
                    <Input id="actionDate" value={formData?.actionDate || ""} onChange={handleChange} />
                  </div>
                  <div className="">
                    <Label htmlFor="firstName">Action Title</Label>
                    <Input id="actionTitle" value={formData?.actionTitle || ""} onChange={handleChange} />
                  </div>
                  <div className="">
                    <Label htmlFor="firstName">Date Completed</Label>
                    <Input id="dateCompleted" value={formData?.dateCompleted || ""} onChange={handleChange} />
                  </div>
                  <div className="">
                    <Label htmlFor="email">Status</Label>
                    <Select
                      options={[
                        { value: "Completed", label: "Completed" },
                        { value: "Not Completed", label: "Not Completed" },
                      ]}
                      value={formData?.status}
                      placeholder="Select an option"
                      onChange={(val) => {
                        setFormData({
                          ...formData,
                          status: val,
                          dateCompleted: val === "Completed" ? getTodayDate() : "",
                        });
                      }}
                    />
                  </div>
                  <div className="col-span-2">
                    <Label htmlFor="street">Inspection Item</Label>
                    <Input type="text" value={formData?.inspectionItem || ""} onChange={handleChange} />
                  </div>
                </div>
              </div>
            </div>
            <div className="space-y-6">
              <div className="rounded-2xl border border-gray-200 bg-white p-6 shadow-sm dark:border-gray-800 dark:bg-gray-900">
                <div>
                  <Label>Remedial Action Remarks</Label>
                  <textarea
                    className={"w-full rounded-lg border px-4 py-2.5 text-sm shadow-theme-xs focus:outline-none text-gray-600 border-gray-300 focus:border-brand-300 focus:ring focus:ring-brand-500/10 dark:border-gray-700 dark:bg-gray-900 dark:text-white/90 dark:focus:border-brand-800"}
                    rows={2}
                  />
                </div>
                <div className="rounded-2xl border border-gray-200 bg-white p-6 shadow-sm dark:border-gray-800 dark:bg-gray-900">
                  <Label>Remedial Action Remarks History</Label>
                  <textarea
                    className="w-full rounded-lg border px-4 py-2.5 text-sm shadow-theme-xs
                      focus:outline-none text-gray-600 border-gray-300
                      dark:border-gray-700 dark:bg-gray-900 dark:text-white/90"
                    rows={6}
                    value={formData?.remarks}
                  />
                </div>
              </div>
              <div className="flex gap-3">
                <Button size="sm" type="submit">
                  Updates
                </Button>
                <Button
                  size="sm"
                  variant="outline"
                  type="button"
                  onClick={() => navigate("/remedial-actions")}
                >
                  Cancel
                </Button>
              </div>
            </div>
          </div>
        </Form>
      </ComponentCard>
    </>
  )
}